/**
 * English word time + calendar line (matches longform analog clock widget).
 * @param {Date} [now]
 * @returns {{ hourWord: string, minuteWord: string, calendarLine: string }}
 */
export function formatLongformClockDisplay(now = new Date()) {
  const hourWord = hour12ToWord(now.getHours());
  const minuteWord = minutesToWord(now.getMinutes());
  const day = now.toLocaleDateString("en-US", { weekday: "short" });
  const mon = now.toLocaleDateString("en-US", { month: "short" });
  const dt = String(now.getDate()).padStart(2, "0");
  const calendarLine = `${day.toUpperCase()} | ${mon.toUpperCase()} | ${dt}`;
  return { hourWord, minuteWord, calendarLine };
}

/** Index = hour24 % 12 (0 and 12 → "twelve", 1 → "one", …, 11 → "eleven"). */
const HOUR_BY_MOD12 = [
  "twelve",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
];

/** @param {number} h24 0–23 local */
function hour12ToWord(h24) {
  return HOUR_BY_MOD12[h24 % 12] || "twelve";
}

const ONES = [
  "",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
];
const TEENS = [
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen",
];
const TENS = ["", "", "twenty", "thirty", "forty", "fifty"];

/** @param {number} m 0–59 */
function minutesToWord(m) {
  if (m === 0) return "";
  if (m < 10) return ONES[m];
  if (m < 20) return TEENS[m - 10];
  const t = Math.floor(m / 10);
  const o = m % 10;
  if (o === 0) return TENS[t];
  return `${TENS[t]} ${ONES[o]}`;
}
